import { Alert } from "@material-ui/lab";
import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import Notification from "../../../elements/notification/Notification";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import RenderStatus from "../../../styles/styledStatus";
import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../styles/styledTable";

const DocumentList = ({ document }) => {
  const { t } = useTranslation("documentsPage");
  const [copy, setCopy] = useState(false);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  if (!document) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }
  if (document.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  const showDetails = (e) => {
    if (e.target.closest(".stop-event")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledScrollTable>
        <StyledTable
          width="1280"
          size="16"
          className="document-table"
        >
          <StyledTableHead
            scroll="auto"
            col="5"
            className="document-table__head"
          >
            <div>
              {t("table.project")}
            </div>
            <div>
              E-mail
            </div>
            <div>
              {t("table.status")}
            </div>
            <div>
              {t("table.schema")}
            </div>
            <div>
              {t("table.date")}
            </div>
          </StyledTableHead>
          <StyledTableBody>
            {document && document.map((value, key) => (
              <StyledTableRow
                key={key}
                scroll="auto"
                col="5"
                className="document-table__row"
                onClick={(e) => {showDetails(e);}}
                cursor="pointer"
                as={NavLink}
                to={`/documents/amlBot/${value.id}`}
              >
                <StyledCol>
                  {value.connection.project.name}
                </StyledCol>
                <StyledCol>
                  <CopyToClipboard
                    className="stop-event"
                    text={value.email}
                    onCopy={() => {
                      setCopy(true);
                      setNotification({ ...notification, visible: true, type: "success", message: t("table.copied") });
                    }}
                  >
                    <div className="document-table__email">
                      {value.attributes?.find((item) => item.attribute.name === "email")?.value ?? "--"}
                    </div>
                  </CopyToClipboard>
                </StyledCol>
                <StyledCol inline>
                  <RenderStatus status={value.status.value} />
                </StyledCol>
                <StyledCol>
                  {value.schema.name}
                </StyledCol>
                <StyledCol>
                  {TimestampToDateMoment(value.createdAt)}
                </StyledCol>
              </StyledTableRow>
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
    </>
  );
};

export default DocumentList;